// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"69fb84ba","60":"546555f3","101":"d8b69483","177":"7fa2109b","294":"ae2bf0f3","316":"e32c3095","381":"2848e96c","453":"99dcf01f","461":"9fbebdcd","512":"73f4c79d","591":"f552156e","668":"f426db02","684":"ad137544","702":"8a406ee9","919":"79f80779","986":"81645049"}[chunkId] + ".chunk.js";
};